import { memo, useMemo } from "react";
import { SimpleSelect, SimpleSelectProps } from "../SimpleSelect";

type YearValue = number | null | undefined;

export type YearFieldProps = SimpleSelectProps<YearValue> & {
  reverse?: boolean,
  min?: number,
  max?: number,
}

export const YearField = memo<YearFieldProps>((
  {
    reverse = true,
    max = new Date().getFullYear(),
    min = new Date().getFullYear() - 50,
    options,
    ...props
  },
) => {

  const wrappedOptions = useMemo(() => {
    if (options) {
      return options;
    }

    const newOptions = [];
    for (let i = min; i <= max; i++) {
      newOptions.push(i);
    }

    if (reverse) {
      return newOptions.reverse();
    }

    return newOptions;
  }, [ options, min, max, reverse ]);


  return (
    <SimpleSelect
      isSearchable
      placeholder="XXXX"
      options={wrappedOptions}
      {...props}
    />
  );
});

export default YearField;
